import { useMemo } from 'react';

import { getPostSubmitSuccess, type PostSubmitSuccess } from '@/util/postSubmitSuccess';

type PostSubmitSearchParams = {
  focusId?: string | string[];
  productSupport?: string | string[];
  productId?: string | string[];
  prefill?: string | string[];
  prefillMessage?: string | string[];
  testPrefill?: string | string[];
  testMessage?: string | string[];
};

type UsePostSubmitSuccessResult = {
  success: PostSubmitSuccess;
  focusId?: string;
  isPrefillEnabled: boolean;
  prefillMessageParam?: string;
};

function firstParamValue(value?: string | string[]): string | undefined {
  return Array.isArray(value) ? value[0] : value;
}

export function usePostSubmitSuccess(
  params: PostSubmitSearchParams,
  isProductSupportSuccessFlagEnabled: boolean
): UsePostSubmitSuccessResult {
  const focusId = firstParamValue(params.focusId);

  const productSupportParam = firstParamValue(params.productSupport);

  const productIdRaw = firstParamValue(params.productId);

  const prefillRaw = firstParamValue(params.prefill) ?? firstParamValue(params.testPrefill);

  const prefillMessageParam =
    firstParamValue(params.prefillMessage) ?? firstParamValue(params.testMessage);

  const success = useMemo(
    () =>
      getPostSubmitSuccess({
        isProductSupportSuccessFlagEnabled,
        productSupportParam,
        productIdRaw,
      }),
    [isProductSupportSuccessFlagEnabled, productSupportParam, productIdRaw]
  );

  return {
    success,
    focusId,
    isPrefillEnabled: prefillRaw === '1',
    prefillMessageParam,
  };
}
